import React from 'react'
import className from 'classnames/bind'

import style from './CommonLayout.module.scss'

import BlindContent from '@Components/atoms/BlindContent'

const cx = className.bind(style)

type Props = {
  children?: React.ReactNode
}

const CommonLayout: React.FC<Props> = ({ children }: Props) => {
  return (
    <section id="content" className={cx('article')} role="main">
      <BlindContent />
      {children}
    </section>
  )
}

export default CommonLayout
